import { render } from "./TenantUserSelect.vue?vue&type=template&id=d905c8bc"
import script from "./TenantUserSelect.vue?vue&type=script&lang=js"
export * from "./TenantUserSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__